import { ActivityType } from 'app/frontend/types/custom'
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'

type TeamEventPlanningInfoContextValue = {
  showPlanningInfo: boolean
  setShowPlanningInfo: (value: boolean) => void
}

const TeamEventPlanningInfoContext =
  createContext<TeamEventPlanningInfoContextValue | null>(null)

type TeamEventPlanningInfoProviderProps = {
  value: TeamEventPlanningInfoContextValue
  children: ReactNode
}

export const TeamEventPlanningInfoProvider = ({
  value,
  children,
}: TeamEventPlanningInfoProviderProps) => {
  return (
    <TeamEventPlanningInfoContext.Provider value={value}>
      {children}
    </TeamEventPlanningInfoContext.Provider>
  )
}

export const useTeamEventPlanningInfoState = (
  teamId: number,
  activityType: ActivityType,
) => {
  const planningInfoStorageKey = `teamEventPlanningInfo:${teamId}`
  const [showPlanningInfo, setShowPlanningInfo] = useState(false)

  useEffect(() => {
    const storedValue = localStorage.getItem(planningInfoStorageKey)
    if (storedValue === 'true' && activityType === 'raids') {
      setShowPlanningInfo(true)
      return
    }

    setShowPlanningInfo(false)
  }, [planningInfoStorageKey])

  useEffect(() => {
    localStorage.setItem(planningInfoStorageKey, String(showPlanningInfo))
  }, [planningInfoStorageKey, showPlanningInfo])

  return { showPlanningInfo, setShowPlanningInfo }
}

export const useTeamEventPlanningInfoContext = () => {
  const context = useContext(TeamEventPlanningInfoContext)
  if (!context) {
    throw new Error(
      'useTeamEventPlanningInfoContext must be used within provider',
    )
  }
  return context
}
